import { Outlet, useLocation } from "react-router-dom";
import Navbar from './Navbar';
import Footer from './Footer';
import { useContext, useEffect } from "react";
import dataApplicationsContext from "../context/dataApplicationsContext";

const Layout = () => {
  const { setWindowWidth } = useContext(dataApplicationsContext);

  const location = useLocation();
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="mainContainer" id={location.pathname === "/" ? "mainContainer-home" : ''}>
        {/* {location.pathname !== "/" && <Sidebar />} */}
        <Outlet />
      </div>
        
      <Footer />
    </>
  )
}

export default Layout
